export default __webpack_public_path__ + "static/media/popover_done.43163dbb.svg";